import { jsx } from 'react/jsx-runtime';
import './_tslib-ff3a08af.js';
import '@material-ui/core/SvgIcon';
import 'react';
import { C as CaretDownIcon } from './CaretDownIcon-6dbf2495.js';

var DropdownIndicator = function () {
    return jsx(CaretDownIcon, { style: { height: '8px', width: '12px', margin: ' 0 12px' } });
};

export { DropdownIndicator as D };
